import { render, staticRenderFns } from "./checkboxSaveId.vue?vue&type=template&id=66de87db&scoped=true&"
import script from "./checkboxSaveId.vue?vue&type=script&lang=js&"
export * from "./checkboxSaveId.vue?vue&type=script&lang=js&"
import style0 from "./checkboxSaveId.vue?vue&type=style&index=0&id=66de87db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66de87db",
  null
  
)

export default component.exports